import React from "react";
import "../components/Style.css"; // Fixed relative path
import { Link as RouterLink } from "react-router-dom";
import banner from "../assets/banner.jpg";

// Import images from assets
import perfectHolidays from "../assets/brands/perfectholidays.jpg";
import getaflight from "../assets/brands/getaflight.jpg";
import checkAHoliday from "../assets/brands/checkaholiday.jpg";
import callForumRah from "../assets/brands/callforumrah.jpg";
import getACruise from "../assets/brands/getacruise.jpg";
import clickAHoliday from "../assets/brands/clickaholdiay.jpg";
import voliamo from "../assets/brands/checkaholiday.jpg";
import filipinoTravel from "../assets/brands/philipino.jpg";
import getaflightUSA from "../assets/brands/getaflightUSA.jpg";
import perfectBusinessTravel from "../assets/brands/perfecrbuissness.jpg";

const Brands = () => {
  const brandData = [
    {
      link: "https://www.perfectholidays.com/",
      imgSrc: perfectHolidays,
      alt: "Perfect Holidays",
      summaries: [
        "We are proud to be one of the leading independent Long Haul Travel Specialists, providing exceptional packages to Florida, the US, Caribbean, Far East, Middle East and Indian Ocean.",
        "With over 50 years of staff experience between us, we bring together the world’s most fascinating destinations, finest hotels, and imaginative tours.",
      ],
    },
    {
      link: "https://www.getaflight.co.uk/",
      imgSrc: getaflight,
      alt: "Getaflight",
      summaries: [
        "Getaflight is an OTA (online travel agency), providing an uncomplicated and seamless booking experience for its customers. We offer the best available fares, combining a state of the art booking engine alongside a super-fast and user friendly website.",
      ],
    },
    {
      link: "https://checkaholiday.co.uk/",
      imgSrc: checkAHoliday,
      alt: "CheckAHoliday",
      summaries: [
        "Checkaholiday is characterized to be one of the best holiday providers in the world. We are well-known for offering exceptional packages with amazing discounts and exclusive deals to all vast landscapes of the world.",
        "We have different teams from different places around the world who have good experience in serving our customers most memorable experience.",
      ],
    },
    {
      link: "https://callforumrah.com/",
      imgSrc: callForumRah,
      alt: "CallForumRah",
      summaries: [
        "MOFA approved agent by the Hajj & Umrah Ministry Saudi Arabia, providing expertise in Flights, Hotels, Umrah and Hajj Packages specialising in last minute deals.",
        "By being appointed official Travel Agent for over 100 Airlines, we provide the best air fares for all International Airlines to our clients from varied departure points.",
      ],
    },
    {
      link: "https://getacruise.com/",
      imgSrc: getACruise,
      alt: "GetACruise",
      summaries: [
        "Our goal is help you, the adventurer, find the perfect cruise holiday. Our experts have a passion for cruising and provide you first-hand experience and knowledge of the destinations, hotels and ships we offer.",
        "We work with all major cruise lines, airlines and accommodation providers worldwide to offer something to suit every taste and budget.",
      ],
    },
    {
      link: "https://clickaholiday.co.uk/",
      imgSrc: clickAHoliday,
      alt: "ClickAHoliday",
      summaries: [
        "We are privileged to be one of the best holiday provider in the world. We are known to provide exceptional packages to almost all parts of the world. We have separate teams of every sector of the world, which have pretty good experience in order to serve our customer most memorable experience.",
        "We are specialized in providing packages to Florida, the US and the Caribbean, the Far East, Middle East and Indian Ocean.",
      ],
    },
    {
      link: "https://www.voliamo.eu/",
      imgSrc: voliamo,
      alt: "Voliamo",
      summaries: [
        "Voliamo offers the most competitive fares via offline and online channels, offering thousands of air fares which cover hundreds of routes around the world, including a selection of over 40,000 hotels.",
      ],
    },
    {
      link: "http://filipinotravelcenter.co.uk/",
      imgSrc: filipinoTravel,
      alt: "Filipino Travel Center",
      summaries: [
        "Planning overseas travel wants expert knowledge regarding places to explore, best airfares, hotels, and guides. That's why Filipino Travel Center offers top-flight deals from the UK to the Philippines. It includes cheaper air tickets, 24-hour customer support.",
      ],
    },
    {
      link: "https://www.getaflightusa.com/",
      imgSrc: getaflightUSA,
      alt: "Getaflight USA",
      summaries: [
        "We are proud to be one of the leading independent online travel agent providing exceptional flight deals from the USA to the world. With over 50 years of staff experience between us, we bring together the world's most fascinating destinations, finest hotels, and imaginative tours.",
      ],
    },
    {
      link: "https://www.perfectbusinesstravel.co.uk/",
      imgSrc: perfectBusinessTravel,
      alt: "Perfect Business Travel",
      summaries: [
        "We’ve still got humans behind the curtains who are always refreshingly ready to service you and set apart the service excellence level dedicatedly for you. We’re here to look after you & your travel needs and all it takes is a call to reach our professional agents.",
      ],
    },
  ];

  return (
    <>
      {/* Breadcrumb Banner */}
      <section
        className="breadcrumb-banner"
        style={{ backgroundImage: `url("${banner}")` }}
      >
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">Brands</h1>
          <p className="breadcrumb-path">
            <RouterLink to="/" className="breadcrumb-link">
              Home
            </RouterLink>{" "}
            / About Us
          </p>
        </div>
      </section>

      {/* Brands Grid */}
      <section className="brands-section">
        <div className="brands-container">
          {brandData.map((brand, index) => (
            <div key={index} className="brand-card">
              {/* Image */}
              <div className="brand-img-wrapper">
                <a href={brand.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={brand.imgSrc}
                    alt={brand.alt}
                    className="brand-img"
                  />
                </a>
              </div>

              {/* Content */}
              <div className="brand-content">
                <h3 className="brand-title">{brand.alt}</h3>
                {brand.summaries.map((summary, i) => (
                  <p key={i} className="brand-summary">
                    {summary}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Brands;
